// extracted by mini-css-extract-plugin
module.exports = {"theComp":"G_theComp__Ly3tx","swiperTool":"G_swiperTool__mgRl4"};